import React, { useContext, useEffect } from "react";
import { DataContext } from "../../Context/Context";
import Navbar from "../Navbar";
import NavbarBottom from "../NavbarBottom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import ModalEntries from "./ModalEntries";
import ContextMenu from "./ContextMenu";
import { IconPickerItem } from "react-fa-icon-picker";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      width: theme.spacing(16),
    },
    marginTop: 60,
  },
  paper: {
    width: "100%",
    marginTop: 30,
  },
  paperTitle: {
    fontSize: 15,
    textAlign: "left",
    margin: 0,
    color: "grey",
    fontWeight: 600,
    padding: "10px 10px",
    backgroundColor: "rgb(240, 238, 238)",
  },
  entriesWrapper: {
    width: "90%",
    margin: "0 auto",
    paddingLeft: 0,
    marginBottom: 80,
  },
  entries: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 5,
    marginBottom: 5,
    cursor: "pointer",
  },
  nameAndDate: {
    marginLeft: 15,
  },
  name: {
    textAlign: "left",
  },
  expenseColor: {
    color: "#b30a2e",
    marginTop: 14,
  },
  incomeColor: {
    color: "#088d80",
    marginTop: 14,
  },
  date: {
    fontSize: 9,
    color: "grey",
  },
  incomeExpenseWrapper: {
    width: "90%",
    margin: "0 auto",
    paddingLeft: 0,
  },
  incomeExpenseLi: {
    display: "flex",
    marginTop: 15,
    marginBottom: 5,
  },
  liRight: {
    flexGrow: 1,
    paddingLeft: 20,
  },
  nameAndSum: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 5,
  },
  deleteEntry: {
    color: "red",
  },
  biggerAmount: {
    color: "#b30a2e",
    fontWeight: "bold",
  },
}));

export default function Overview() {
  const classes = useStyles();

  const {
    income,
    expense,
    entries,
    setOpenEntryModal,
    setEditingEntry,
    setAddNewItem,
    editingEntry,
    contextMenu,
    setContextMenu,
    wizardCategories,
  } = useContext(DataContext);

  const handleUpdate = (e, editingItem, index) => {
    if (e.which !== 2 || e.which !== 3) {
      setOpenEntryModal(true);

      setEditingEntry(index);

      console.log("editing entry", editingEntry);

      setAddNewItem({
        id: editingItem.id,
        type: editingItem.type,
        category: editingItem.category,
        amount: editingItem.amount,
        date: editingItem.date,
        desc: editingItem.desc,
      });
    }
  };

  const handleContextMenu = (event) => {
    event.preventDefault();

    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
          }
        : null
    );

    let filteredEntry = entries.filter((e) => {
      return e.id == event.target.id;
    });

    console.log("filtered entry", filteredEntry);

    console.log("event target id", event.target.id);

    filteredEntry = filteredEntry.length ? filteredEntry[0] : {};

    setAddNewItem({
      id: filteredEntry.id,
      type: filteredEntry.type,
      category: filteredEntry.category,
      amount: filteredEntry.amount,
      date: filteredEntry.date,
      desc: filteredEntry.desc,
    });
  };

  return (
    <>
      <Navbar />
      <div className={classes.root}>
        <Paper elevation={3} className={classes.paper}>
          <p className={classes.paperTitle}>Income</p>
          <ul className={classes.incomeExpenseWrapper}>
            {income.map((i) => {
              let category = wizardCategories.filter((cat) => i.id === cat.id);
              category = category[0] || {};
              return (
                <li key={category.name} className={classes.incomeExpenseLi}>
                  <IconPickerItem color="inherit" icon={category.icon}>
                    {category.icon}
                  </IconPickerItem>
                  <div className={classes.liRight}>
                    <div className={classes.nameAndSum}>
                      <div>{category.name}</div>
                      <div>
                        {i.amount}
                        {category.budget > 0 ? "/" : null}
                        {category.budget}
                      </div>
                    </div>
                    <div>
                      <Box sx={{ width: "100%" }}>
                        <LinearProgress
                          variant="determinate"
                          value={(i.amount / category.budget) * 100}
                        />
                      </Box>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </Paper>
        <Paper elevation={3} className={classes.paper}>
          <p className={classes.paperTitle}>Expenses</p>
          <ul className={classes.incomeExpenseWrapper}>
            {expense.map((e) => {
              let category = wizardCategories.filter((cat) => e.id === cat.id);
              category = category[0] || {};
              return (
                <li key={category.name} className={classes.incomeExpenseLi}>
                  <IconPickerItem color="inherit" icon={category.icon}>
                    {category.icon}
                  </IconPickerItem>
                  <div className={classes.liRight}>
                    <div className={classes.nameAndSum}>
                      <div>{category.name}</div>
                      <div>
                        {e.amount}
                        {category.budget > 0 ? "/" : null}
                        {category.budget}
                      </div>
                    </div>
                    <div>
                      <Box sx={{ width: "100%" }}>
                        <LinearProgress
                          variant="determinate"
                          value={(e.amount / category.budget) * 100}
                        />
                      </Box>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </Paper>
        <div style={{ cursor: "context-menu" }} className={classes.paper}>
          <Paper elevation={3}>
            <p className={classes.paperTitle}>Entries</p>
            <ul className={classes.entriesWrapper}>
              {entries.map((entry, index) => {
                return (
                  <li
                    key={entry.id}
                    id={entry.id}
                    onContextMenu={handleContextMenu}
                    onClick={(e) => {
                      handleUpdate(e, entry, index);
                    }}
                    className={classes.entries}
                  >
                    <div
                      style={{ pointerEvents: "none" }}
                      className={classes.entries}
                    >
                      <IconPickerItem
                        color="inherit"
                        icon={entry.category.icon}
                      >
                        {entry.category.icon}
                      </IconPickerItem>
                      <div className={classes.nameAndDate}>
                        <div className={classes.name}>
                          {entry.category.name}
                        </div>
                        <span className={classes.date}>
                          {new Date(entry.date).toLocaleDateString("en-GB")}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{ pointerEvents: "none" }}
                      className={
                        entry.type === "Expense"
                          ? classes.expenseColor
                          : classes.incomeColor
                      }
                    >
                      {`${
                        entry.type === "Expense"
                          ? "-" + entry.amount
                          : "+" + entry.amount
                      } `}
                    </div>
                  </li>
                );
              })}
            </ul>
            <ContextMenu />
          </Paper>
        </div>
      </div>
      <ModalEntries />
      <NavbarBottom />
    </>
  );
}
